import {NavItem} from "./NavItem";

export class Navigation {

  constructor(public groupName: string
              , public navItems: NavItem[]) {}

}
